module.exports = __webpack_public_path__ + "static/media/calenderIcon.40bb18ad.svg";